import { render, staticRenderFns } from "./compleate_registration.vue?vue&type=template&id=13e63b76&scoped=true&"
import script from "./compleate_registration.vue?vue&type=script&lang=js&"
export * from "./compleate_registration.vue?vue&type=script&lang=js&"
import style0 from "./compleate_registration.vue?vue&type=style&index=0&id=13e63b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e63b76",
  null
  
)

export default component.exports